"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KansaReportChart = void 0;
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _CRadarChart = _interopRequireDefault(require("../../../common/components/materials/CRadarChart"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 成熟度評価サマリ
 */
const KansaReportChart = props => {
  const {
    intl,
    getCodeName,
    entries
  } = props;
  const {
    seijukudoSumList,
    seijukudoChartList
  } = entries;
  const attr = [];
  let len = 0;
  if (Array.isArray(seijukudoSumList)) {
    len = seijukudoSumList.length;
  }
  for (let i = 0; i < len; ++i) {
    const code = seijukudoSumList[i].seijukudoHyokaSumKbnCd;
    switch (code) {
      case _CodeConsts.CODE.KANSA_ME_SUMKBN.CODE_1:
        attr.push({
          name: getCodeName(_CodeConsts.CODE.KANSA_ME_SUMKBN.KBN, code),
          key: 'konnendoScore',
          color: '#007B50'
        });
        break;
      case _CodeConsts.CODE.KANSA_ME_SUMKBN.CODE_2:
        attr.push({
          name: getCodeName(_CodeConsts.CODE.KANSA_ME_SUMKBN.KBN, code),
          key: 'zennendoScore',
          color: '#EB6940'
        });
        break;
      case _CodeConsts.CODE.KANSA_ME_SUMKBN.CODE_3:
        attr.push({
          name: getCodeName(_CodeConsts.CODE.KANSA_ME_SUMKBN.KBN, code),
          key: 'averageScore',
          color: '#4347A2'
        });
        break;
      default:
        break;
    }
  }
  if (!attr || attr.length === 0 || !seijukudoChartList || seijukudoChartList.length === 0) {
    return /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_SEJUKUDO_HYOKA_SUMMARY
      })
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, null, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_REPORT_SEIJUKUDO_HYOKA_NOT_FOUND
    })));
  }
  return /*#__PURE__*/_react.default.createElement(_CRadarChart.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SEJUKUDO_HYOKA_SUMMARY
    }),
    chartHeight: 450,
    chartWidth: 650,
    domainMax: entries.maxPoints,
    radarAttr: attr,
    chartData: seijukudoChartList,
    dataKey: "columnNm",
    tickCount: entries.maxPoints + 2
  });
};
exports.KansaReportChart = KansaReportChart;
var _default = exports.default = (0, _reactIntl.injectIntl)((0, _CodeUtil.withCodeUtil)(KansaReportChart));